module.exports = __webpack_public_path__ + "static/img/qick_img03.0ea36723.png";